
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function TestimonialsSection() {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.1 });

  const niches = [
    { icon: 'ri-scissors-cut-line', name: 'Barbearias' },
    { icon: 'ri-hospital-line', name: 'Clínicas' },
    { icon: 'ri-home-4-line', name: 'Imobiliárias' },
    { icon: 'ri-car-line', name: 'Concessionárias' },
    { icon: 'ri-run-line', name: 'Academias' },
    { icon: 'ri-store-2-line', name: 'Negócios Locais' },
    { icon: 'ri-global-line', name: 'E-commerce' },
    { icon: 'ri-briefcase-line', name: 'Serviços B2B' },
  ];

  return (
    <section className="py-16 sm:py-24 bg-black">
      <div ref={sectionRef} className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid md:grid-cols-5 gap-8 sm:gap-12 items-center">
          <div 
            className={`md:col-span-2 transition-all duration-700 ease-out ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
            }`}
          >
            <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden max-w-xs mx-auto md:max-w-none">
              <img
                src="https://static.readdy.ai/image/607c853629dc4b228801d270367dd43a/222553bcfacb5980c58e566eed5bdd2d.jpeg"
                alt="Rafael F. Silva - CEO NeuroAgents"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          <div className="md:col-span-3 space-y-4 sm:space-y-6">
            <span 
              className={`inline-block px-3 sm:px-4 py-1.5 sm:py-2 bg-gray-800 text-gray-400 text-xs sm:text-sm font-semibold rounded-full whitespace-nowrap transition-all duration-700 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: '100ms' }}
            >
              (CEO)
            </span>

            <h2 
              className={`text-2xl sm:text-3xl md:text-4xl font-bold leading-tight transition-all duration-700 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: '200ms' }}
            >
              Implementação <span className="text-primary">Personalizada</span>
            </h2>

            <blockquote 
              className={`text-sm sm:text-lg md:text-xl text-gray-300 leading-relaxed border-l-4 border-primary pl-4 sm:pl-6 italic transition-all duration-700 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: '300ms' }}
            >
              "Cada negócio tem sua particularidade. Por isso, fazemos a implementação personalizada e gratuita, ajustando a IA para falar a linguagem do seu cliente e resolver os problemas específicos do seu mercado."
            </blockquote>

            <div 
              className={`pt-3 sm:pt-4 transition-all duration-700 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: '400ms' }}
            >
              <p className="text-xs sm:text-sm text-gray-500 mb-4 sm:mb-6">Aplicável a diversos nichos:</p>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4">
                {niches.map((niche, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-2 text-gray-400 hover:text-primary transition-colors"
                  >
                    <div className="w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center">
                      <i className={`${niche.icon} text-lg sm:text-xl`}></i>
                    </div>
                    <span className="text-xs sm:text-sm font-medium whitespace-nowrap">{niche.name}</span>
                  </div>
                ))}
              </div>
            </div>

            <div 
              className={`pt-4 sm:pt-6 transition-all duration-700 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: '500ms' }}
            >
              <p className="font-bold text-white text-sm sm:text-base">— Rafael F. Silva</p>
              <p className="text-xs sm:text-sm text-gray-400">CEO, NeuroAgents Global AI</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
